<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filterParams.year"
            :options="filterData.years"
            placeholder="Yıl"
            label="year"
            :reduce="item => item.year"
            :clearable="false"
          />
        </b-col>
        <b-col
          cols="12"
          md="5"
        >
          <b-input-group>
            <b-form-datepicker
              id="sdate"
              v-model="filterParams.sdate"
              v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              locale="tr"
              start-weekday="1"
              :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
              class="border-right-0"
            />
            <b-input-group-addon is-text>
              -
            </b-input-group-addon>
            <b-form-datepicker
              id="edate"
              v-model="filterParams.edate"
              v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
              locale="tr"
              start-weekday="1"
              :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
            />
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <div class="d-flex justify-content-between align-items-center">
            <b-button
              variant="primary"
              class="w-100 mr-1"
              :disabled="!filterParams.sdate || !filterParams.edate || !filterParams.year"
              @click="getReport"
            >
              <FeatherIcon icon="FilterIcon" /> Raporu Göster
            </b-button>
            <b-button
              variant="danger"
              class="w-100"
              :href="downloadPDF"
              target="_blank"
              :disabled="!filterParams.sdate || !filterParams.edate || !filterParams.year"
            >
              <FeatherIcon icon="DownloadIcon" />
              PDF İndir
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BButton, BCard, BFormDatepicker, BInputGroup, BInputGroupAddon, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'FilterCard',
  components: {
    BFormDatepicker,
    BInputGroupAddon,
    BInputGroup,
    BButton,
    BCard,
    BRow,
    BCol,
    vSelect,
  },
  props: {
    getReport: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['directorReports/filterParams']
    },
    filterData() {
      return this.$store.getters['directorReports/filterData']
    },
    downloadPDF() {
      const downloadToken = localStorage.getItem('downloadToken')
      let url = this.$store.state.app.baseURL
      url += `/Exports/reports/director_reports?token=${downloadToken}`
      if (this.filterParams.sdate) {
        url += `&sdate=${this.filterParams.sdate}`
      }
      if (this.filterParams.sdate) {
        url += `&edate=${this.filterParams.edate}`
      }
      if (this.filterParams.year) {
        url += `&year=${this.filterParams.year}`
      }
      return url
    },
  },
  created() {
    this.getFilterData()
  },
  methods: {
    getFilterData() {
      this.$store.dispatch('directorReports/getFilterData')
    },
  },
}
</script>
